import { createContext, useContext, useEffect, useState } from 'react';

const THEME_KEY = 'ui-theme';

type Theme = 'light' | 'dark';

type ThemeContextValue = {
  theme: Theme;
  toggleTheme: () => void;
};

const ThemeContext = createContext<ThemeContextValue | undefined>(undefined);

const getSystemTheme = (): Theme => {
  return 'light';
  // TODO: Uncomment this when dark mode is implemented
  // if (typeof window === 'undefined' || !window.matchMedia) {
  //   return 'light';
  // }
  // return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
};

const getStoredTheme = (): Theme | null => {
  if (typeof localStorage === 'undefined') {
    return null;
  }
  const stored = localStorage.getItem(THEME_KEY) as Theme | null;
  return stored === 'light' || stored === 'dark' ? stored : null;
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const applyTheme = (theme: Theme) => {
  // TODO: Uncomment this when dark mode is implemented
  // const root = document.documentElement;
  // if (theme === 'dark') {
  //   root.classList.add('dark');
  // } else {
  //   root.classList.remove('dark');
  // }
};

interface ThemeProviderProps {
  children: React.ReactNode;
}

const ThemeProvider = ({ children }: ThemeProviderProps) => {
  const [theme, setTheme] = useState<Theme>(() => getStoredTheme() ?? getSystemTheme());

  useEffect(() => {
    applyTheme(theme);
  }, [theme]);

  const toggleTheme = () => {
    setTheme((prev) => (prev === 'dark' ? 'light' : 'dark'));
  };

  useEffect(() => {
    localStorage.setItem(THEME_KEY, theme);
  }, [theme]);

  return <ThemeContext.Provider value={{ theme, toggleTheme }}>{children}</ThemeContext.Provider>;
};

const useTheme = (): ThemeContextValue => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};

export { ThemeProvider, useTheme };
export type { Theme };
